import { render } from "./TagMenuOptions.vue?vue&type=template&id=3f79aac6&scoped=true"
import script from "./TagMenuOptions.vue?vue&type=script&lang=js"
export * from "./TagMenuOptions.vue?vue&type=script&lang=js"

import "./TagMenuOptions.vue?vue&type=style&index=0&id=3f79aac6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f79aac6"]])

export default __exports__